@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title }}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- CARD & VEHICLE -->
      <div class="row mt-3">
        @if (isCardConsumption) {
          <div class="col-sm-6">
            <label for="cardConsumption-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.card' | translate}}
                </label>
            <p-select [options]='cardList' [(ngModel)]='entity.card' [disabled]="!editCard || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
              [placeholder]="cardPlaceholder" dataKey='id'
              optionLabel='number' [style]="{'width':'250px'}" appendTo='body' [filter]="true" filterBy="number"
              (onChange)="onChangeCard($event)" (onFilter)="onFilterCard($event)">
            </p-select>
          </div>
        }
        <div class="col-sm-6">
          <label for="cardConsumption-vehicle" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    <strong> {{'tableManagement.cardsConsumption.vehicle' | translate}} (*)</strong>
                </label>
          <p-select [options]='vehicleList' [(ngModel)]='entity.vehicle' [disabled]="!editCard || entity.card || !editVehicle || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            [placeholder]="vehiclePlaceholder" dataKey='id'
            optionLabel='name' [style]="{'width':'250px'}" appendTo='body' [filter]="true" filterBy="name"
            (onChange)="onChangeVehicle($event)" (onFilter)="onFilterVehicle($event)">
          </p-select>
        </div>
      </div>
      <!-- IMPORT VALUE & CONSUMPTION DATE -->
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cardConsumption-iValue" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    <strong>{{'tableManagement.cardsConsumption.amount' | translate}}</strong>
                </label>
          <div class="input-wrapper">
            <p-inputNumber class="full-width-input-number" [(ngModel)]="entity.amount" mode="decimal" locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
            <span class="input-symbol">€</span>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cardConsumption-date" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    <strong> {{'tableManagement.cardsConsumption.date' | translate}} (*)</strong>
                </label>
          <p-datepicker class="full-width-datepicker" [(ngModel)]='dateConsumption' [showTime]='false'
            showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat='{{i18n.dateFormat}}'
          appendTo='body'></p-datepicker>
        </div>
      </div>
      <!-- LITERS & KMS -->
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cardConsumption-liters" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    <strong>{{'tableManagement.cardsConsumption.litres' | translate}}</strong>
                </label>
          <p-inputNumber class="full-width-input-number" [showButtons]="false" id="cardConsumption-liters" mode="decimal" locale="es-ES"
          [(ngModel)]="entity.liters" (onKeyDown)="onKeyDownDecimal($event)"></p-inputNumber>
        </div>
        <div class="col-sm-6">
          <label for="carConsumption-kms" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    <strong>{{'tableManagement.cardsConsumption.km' | translate}}</strong>
                </label>
          <p-inputNumber class="full-width-input-number" [showButtons]="false" id="carConsumption-kms" mode="decimal" locale="es-ES"
          [(ngModel)]="entity.kms" (onKeyDown)="onKeyDownDecimal($event)"></p-inputNumber>
        </div>
      </div>
      <!-- DIFF KMS & DIFF DAYS -->
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cardConsumption-diffKms" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.diffKms' | translate}}
                </label>
          <p-inputNumber class="full-width-input-number" id="fine-reason" mode="decimal" locale="es-ES" [(ngModel)]="entity.difKms" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
        </div>
        <div class="col-sm-6">
          <label for="cardConsumption-diffDays" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.diffDays' | translate}}
                </label>
          <p-inputNumber class="full-width-input-number" id="cardConsumption-diffDays" mode="decimal" locale="es-ES" [(ngModel)]="entity.difDays" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
        </div>
      </div>
      <!-- DIFF CONSUMPTION & KMS COST -->
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cardConsumption-diffConsumption" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.diffConsumption' | translate}}
                </label>
          <p-inputNumber class="full-width-input-number" id="cardConsumption-diffConsumption" [(ngModel)]="entity.difConsumption" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
        </div>
        <div class="col-sm-6">
          <label for="cardConsumption-kmsCost" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.kmsCost' | translate}}
                </label>
          <p-inputNumber class="full-width-input-number" id="cardConsumption-kmsCost" mode="decimal" locale="es-ES" [(ngModel)]="entity.kmsCost" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
        </div>
      </div>
      <!-- LITER COST -->
      <div class="row mt-3">
        <div class="col-sm-6">
          <label for="cardConsumption-literCost" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardsConsumption.literCost' | translate}}
                </label>
          <p-inputNumber class="full-width-input-number" id="cardConsumption-literCost" mode="decimal" locale="es-ES" [(ngModel)]="entity.literCost" (onKeyDown)="onKeyDownDecimal($event)" [showButtons]="false"></p-inputNumber>
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew && isCreateGranted) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew && isUpdateGranted) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}